export default __webpack_public_path__ + "1017c797378171f6ceba0f1b2ec610b3.svg";